<template>
    <div class="table-container">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th colspan="5" class="text-center">Latest Imports</th>
                </tr>
                <tr>
                    <th scope="col">Table</th>
                    <th scope="col">Status</th>
                    <th scope="col">Started At</th>
                    <th scope="col">Finished At</th>
                    <th scope="col">Error</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="!history.length">
                    <tr>
                        <td colspan="5">No imports</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="record in history" :key="record.id">
                        <td>{{ record?.table?.title }}</td>
                        <td>
                            <template v-if="recordIsSuccessful(record)">
                                <span class="badge badge-success">Success</span>
                            </template>
                            <template v-else>
                                <span class="badge badge-danger">Failed</span>
                            </template>
                        </td>
                        <td>{{ record.started_at }}</td>
                        <td>{{ record.finished_at }}</td>
                        <td>
                            <template v-if="record.error">
                                <ion-icon
                                    class="eye-icon"
                                    name="eye-outline"
                                    @click="showError(record)"
                                ></ion-icon>
                            </template>
                            <template v-else>-</template>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <loading-overlay :loading="isLoading"></loading-overlay>
    </div>
</template>

<script>
const STATUS_NEW = 0;
const STATUS_PROCESSING = 1;
const STATUS_SUCCESS = 2;
const STATUS_ERROR = 3;

export default {
    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            history: [],
        };
    },
    mounted() {
        this.isLoading = true;

        axios
            .get(route("in-form.import.history", { company: this.companyId }))
            .then(({ data }) => (this.history = data))
            .finally(() => (this.isLoading = false));
    },
    methods: {
        recordIsSuccessful(record) {
            return record.status === STATUS_SUCCESS;
        },
        showError(record) {
            window.alert(record.error);
        },
    },
};
</script>

<style scoped lang="scss"></style>
